export default __webpack_public_path__ + "static/media/Gilroy-SemiBoldItalic.56127a25.woff";